import React, { useState } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

const ExperienceAnimation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);

  function toggleExpOpen() {
    setIsOpen(!isOpen);
  }
  function toggleModalTwo() {
    setIsOpen2(!isOpen2);
  }
  function toggleModalThree() {
    setIsOpen3(!isOpen3);
  }
  function toggleModalFour() {
    setIsOpen4(!isOpen4);
  }

  return (
    <div class="container service_list">
      <div
        class="aos-init aos-animate"
        data-aos="fade-right"
        data-aos-duration="1200"
        data-aos-delay=""
      >
        <div class="resume-box-01 experience-bg row">
          <div className="col-4">
            <h5>Software Engineer</h5>
            <h6>Full Time</h6>
            <p>January 2023 - Present</p>
            <br />
            <a href="https://www.cognitusconsulting.com/" target="_blank">
              <h4>
                <label>Cognitus Consulting LLC.</label>
              </h4>
            </a>
          </div>
          <div className="col-8">
            <p>
              <strong>
                Working remotely as a full time software engineer in two core
                team. Also managing a team in one of the house product as a Lead
                Frontend Engineer. My responsibilities are to understand
                business problems and find the efficient solution for that. Also
                working as a full stack engineer in a data centric project.
              </strong>
            </p>

            {isOpen2 && (
              <>
                <br />
                <h4>
                  <strong>🔗 Some Projects I am working on:</strong>
                </h4>

                <ul>
                  <li>Alchemy - Powerfull SAP Data migration tool</li>
                  <li>LambdaX - Ai powered contract management system</li>
                </ul>

                <br />
                <h4>
                  <strong>💡 I am working with these technologies here:</strong>
                </h4>

                <ul>
                  <li>TypeScript</li>
                  <li>React.js</li>
                  <li>Node.js (Express)</li>
                  <li>MongoDB</li>
                  <li>Tailwind/Ant Design</li>
                  <li>Kafka</li>
                  <li>Redis</li>
                  <li>Socket.io</li>
                </ul>
              </>
            )}
            <br />
            <a onClick={toggleModalTwo}>
              <h4>{isOpen ? "Collapse" : "See More"}</h4>
            </a>
          </div>
        </div>
        <div class="resume-box-01 experience-bg row">
          <div className="col-4">
            <h5>Software Engineer</h5>
            <h6>Full Time</h6>
            <p>November 2020 - January 2023</p>
            <br />
            <a href="https://implevista.com/" target="_blank">
              <h4>
                <label>Implevista Bangladesh Ltd.</label>
              </h4>
            </a>
          </div>
          <div className="col-8">
            <p>
              <strong>
                Working as a full time software engineer in a core team.
                Alongside managing a in house product team of Implevista
                Commerce Project. Worked directly with clients. I am responsible
                for requirement &amp; business analysis and finding efficient
                and user friendly solution for a feature.
              </strong>
            </p>

            {isOpen && (
              <>
                <br />
                <h4>
                  <strong>🔗 Some Projects I have worked on:</strong>
                </h4>

                <ul>
                  <li>IVCommerce - SaaS based e-commerce platform</li>
                  <li>
                    Global Expert App - Int Audit &amp; Inventory manager app
                    for Holcim International.
                  </li>
                  <li>E-Kyc - Know Your Customer app</li>
                  <li>
                    Spark Radius - Customer Relationship Management(CRM) mobile
                    applications for Vizag Broadcasting Company LTD
                  </li>
                </ul>

                <br />
                <h4>
                  <strong>
                    💡 I have worked with these technologies here:
                  </strong>
                </h4>

                <ul>
                  <li>React.js</li>
                  <li>Next.js</li>
                  <li>Node.js (Express)</li>
                  <li>MongoDB</li>
                  <li>MySQL</li>
                  <li>Firebase Cloud Function (Node.js/Typescript)</li>
                  <li>React Native</li>
                  <li>Tailwind/Bootstrap/MaterialUI</li>
                  <li>3rd Party API integration</li>
                  <li>Firebase Auth/Firestore/Storage</li>
                  <li>Microsoft Azure Devops</li>
                </ul>
              </>
            )}
            <br />
            <a onClick={toggleExpOpen}>
              <h4>{isOpen ? "Collapse" : "See More"}</h4>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceAnimation;
